import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustSection = () => {
  const stats = [
    { value: '500+', label: 'Partner Schools', icon: 'School' },
    { value: '10,000+', label: 'Active Teachers', icon: 'Users' },
    { value: '50,000+', label: 'Learning Trails', icon: 'BookOpen' },
    { value: '98%', label: 'Satisfaction Rate', icon: 'Heart' },
  ];

  const partners = [
    'National Education Association',
    'International Society for Technology in Education',
    'Association for Supervision and Curriculum Development',
    'Council of Chief State School Officers',
  ];

  return (
    <section className="py-12 md:py-16 lg:py-20 bg-background">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-12 lg:mb-16">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-4 md:mb-6">
            Trusted by Educators Worldwide
          </h2>
          <p className="text-base md:text-lg text-muted-foreground max-w-3xl mx-auto">
            Join thousands of teachers who are transforming education with LearningTrails.
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 mb-12 md:mb-16">
          {stats?.map((stat, index) => (
            <div key={index} className="text-center stagger-fade-in" style={{ animationDelay: `${index * 100}ms` }}>
              <div className="w-12 h-12 md:w-14 md:h-14 lg:w-16 lg:h-16 bg-primary/10 rounded-xl flex items-center justify-center mx-auto mb-3 md:mb-4">
                <Icon name={stat?.icon} size={24} className="text-primary md:w-7 md:h-7 lg:w-8 lg:h-8" />
              </div>
              <p className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-1 md:mb-2">
                {stat?.value}
              </p>
              <p className="text-xs md:text-sm text-muted-foreground">
                {stat?.label}
              </p>
            </div>
          ))}
        </div>

        <div className="bg-card rounded-xl p-6 md:p-8 lg:p-10 shadow-sm">
          <h3 className="text-lg md:text-xl font-semibold text-foreground text-center mb-6 md:mb-8">
            Recognized by Leading Educational Organizations
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
            {partners?.map((partner, index) => (
              <div key={index} className="flex items-center justify-center p-4 bg-muted/30 rounded-lg">
                <Icon name="Award" size={20} className="text-primary mr-3 flex-shrink-0" />
                <span className="text-sm md:text-base text-foreground text-center">
                  {partner}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustSection;